import React from 'react';
import LeafletMap from './LeafletMap';

function EditorMap () {

    return (
        <div className="editor-panel-map">
            <LeafletMap />
        </div>
    );
}

export default EditorMap;